module.exports = __webpack_public_path__ + "img/stu-banner.cb79085e.png";